import styled from '@emotion/styled';
import {
  forwardRef, type MouseEvent, type PropsWithChildren,
} from 'react';

type LimitNumberOfLinesProps = Readonly<{
  maxNumberOfLines: number;
  className?: string;
  onClick?: () => void;
  onDoubleClick?: (e: MouseEvent<HTMLDivElement>) => void;
}>;

// non-standard feature - works with Webkit, Blink and FF, https://caniuse.com/css-line-clamp
const LimitNumberOfLinesWrapper = styled.div<{ readonly maxNumberOfLines: number }>((props) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: props.maxNumberOfLines,
}));

export const LimitNumberOfLinesComponent = forwardRef<HTMLDivElement, PropsWithChildren<LimitNumberOfLinesProps>>(({
  className,
  maxNumberOfLines,
  children,
  ...restProps
}, ref) => {
  return (
    <LimitNumberOfLinesWrapper
      {...restProps}
      className={className}
      maxNumberOfLines={maxNumberOfLines}
      ref={ref}
    >
      {children}
    </LimitNumberOfLinesWrapper>
  );
});
